/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Account Notifications
 * API управления нотификациями рекрутера (TASKNEIROKLYUCH-647): - привязка/отвязка Telegram через Bot API deep link - настройки каналов (email/telegram) и приоритетов по статусам воронки 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Статус воронки из левого фильтра страницы «Диалоги». 
 * @export
 * @enum {string}
 */

export const AccountNotificationFunnelStatus = {
    PROBLEM: 'PROBLEM',
    APPROVED: 'APPROVED',
    FINALIST: 'FINALIST',
    OVERDUE: 'OVERDUE',
    WITH_REPLY: 'WITH_REPLY',
    REJECTED: 'REJECTED',
    DECLINED: 'DECLINED',
    NO_REPLY: 'NO_REPLY'
} as const;

export type AccountNotificationFunnelStatus = typeof AccountNotificationFunnelStatus[keyof typeof AccountNotificationFunnelStatus];


/**
 * 
 * @export
 * @interface AccountNotificationPreferencesPayload
 */
export interface AccountNotificationPreferencesPayload {
    /**
     * Включены ли email-нотификации целиком
     * @type {boolean}
     * @memberof AccountNotificationPreferencesPayload
     */
    'emailEnabled': boolean;
    /**
     * Включены ли Telegram-нотификации целиком
     * @type {boolean}
     * @memberof AccountNotificationPreferencesPayload
     */
    'telegramEnabled': boolean;
    /**
     * Статусы воронки, по которым доставляются email-нотификации (пустой = ни одного; null = все)
     * @type {Array<AccountNotificationFunnelStatus>}
     * @memberof AccountNotificationPreferencesPayload
     */
    'priorityEmail'?: Array<AccountNotificationFunnelStatus>;
    /**
     * Статусы воронки, по которым доставляются Telegram-нотификации
     * @type {Array<AccountNotificationFunnelStatus>}
     * @memberof AccountNotificationPreferencesPayload
     */
    'priorityTelegram'?: Array<AccountNotificationFunnelStatus>;
}
/**
 * 
 * @export
 * @interface AccountTelegramLinkStatusResponse
 */
export interface AccountTelegramLinkStatusResponse {
    /**
     * Привязан ли Telegram (есть заполненный chat_id)
     * @type {boolean}
     * @memberof AccountTelegramLinkStatusResponse
     */
    'linked': boolean;
}
/**
 * 
 * @export
 * @interface AccountTelegramLinkTokenResponse
 */
export interface AccountTelegramLinkTokenResponse {
    /**
     * URL вида `https://t.me/<bot_username>?start=<token>`
     * @type {string}
     * @memberof AccountTelegramLinkTokenResponse
     */
    'deepLink': string;
    /**
     * Когда токен перестаёт быть валидным (ISO-8601, UTC)
     * @type {string}
     * @memberof AccountTelegramLinkTokenResponse
     */
    'expiresAt': string;
}

/**
 * AccountNotificationPreferencesApi - axios parameter creator
 * @export
 */
export const AccountNotificationPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Если настройки ещё не сохранены — возвращает дефолт: все каналы включены, все типы событий доставляются по обоим каналам. 
         * @summary Получить настройки каналов и приоритетов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить настройки
         * @param {AccountNotificationPreferencesPayload} accountNotificationPreferencesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationPreferences: async (accountNotificationPreferencesPayload: AccountNotificationPreferencesPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountNotificationPreferencesPayload' is not null or undefined
            assertParamExists('updateNotificationPreferences', 'accountNotificationPreferencesPayload', accountNotificationPreferencesPayload)
            const localVarPath = `/account/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountNotificationPreferencesPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountNotificationPreferencesApi - functional programming interface
 * @export
 */
export const AccountNotificationPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountNotificationPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * Если настройки ещё не сохранены — возвращает дефолт: все каналы включены, все типы событий доставляются по обоим каналам. 
         * @summary Получить настройки каналов и приоритетов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationPreferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountNotificationPreferencesPayload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationPreferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountNotificationPreferencesApi.getNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить настройки
         * @param {AccountNotificationPreferencesPayload} accountNotificationPreferencesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationPreferences(accountNotificationPreferencesPayload: AccountNotificationPreferencesPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountNotificationPreferencesPayload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationPreferences(accountNotificationPreferencesPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountNotificationPreferencesApi.updateNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountNotificationPreferencesApi - factory interface
 * @export
 */
export const AccountNotificationPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountNotificationPreferencesApiFp(configuration)
    return {
        /**
         * Если настройки ещё не сохранены — возвращает дефолт: все каналы включены, все типы событий доставляются по обоим каналам. 
         * @summary Получить настройки каналов и приоритетов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferences(options?: RawAxiosRequestConfig): AxiosPromise<AccountNotificationPreferencesPayload> {
            return localVarFp.getNotificationPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить настройки
         * @param {AccountNotificationPreferencesPayload} accountNotificationPreferencesPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationPreferences(accountNotificationPreferencesPayload: AccountNotificationPreferencesPayload, options?: RawAxiosRequestConfig): AxiosPromise<AccountNotificationPreferencesPayload> {
            return localVarFp.updateNotificationPreferences(accountNotificationPreferencesPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountNotificationPreferencesApi - object-oriented interface
 * @export
 * @class AccountNotificationPreferencesApi
 * @extends {BaseAPI}
 */
export class AccountNotificationPreferencesApi extends BaseAPI {
    /**
     * Если настройки ещё не сохранены — возвращает дефолт: все каналы включены, все типы событий доставляются по обоим каналам. 
     * @summary Получить настройки каналов и приоритетов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountNotificationPreferencesApi
     */
    public getNotificationPreferences(options?: RawAxiosRequestConfig) {
        return AccountNotificationPreferencesApiFp(this.configuration).getNotificationPreferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить настройки
     * @param {AccountNotificationPreferencesPayload} accountNotificationPreferencesPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountNotificationPreferencesApi
     */
    public updateNotificationPreferences(accountNotificationPreferencesPayload: AccountNotificationPreferencesPayload, options?: RawAxiosRequestConfig) {
        return AccountNotificationPreferencesApiFp(this.configuration).updateNotificationPreferences(accountNotificationPreferencesPayload, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AccountTelegramApi - axios parameter creator
 * @export
 */
export const AccountTelegramApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Возвращает `t.me/<bot>?start=<token>` и время истечения (TTL 10 минут). 
         * @summary Создать одноразовый deep link для привязки Telegram
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/telegram/link-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Узнать подключён ли Telegram
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTelegramLinkStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/telegram/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Очищает `telegram_chat_id` у текущего аккаунта.
         * @summary Отвязать Telegram
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkTelegram: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/telegram`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountTelegramApi - functional programming interface
 * @export
 */
export const AccountTelegramApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountTelegramApiAxiosParamCreator(configuration)
    return {
        /**
         * Возвращает `t.me/<bot>?start=<token>` и время истечения (TTL 10 минут). 
         * @summary Создать одноразовый deep link для привязки Telegram
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLinkToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountTelegramLinkTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLinkToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTelegramApi.createLinkToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Узнать подключён ли Telegram
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTelegramLinkStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountTelegramLinkStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTelegramLinkStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTelegramApi.getTelegramLinkStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Очищает `telegram_chat_id` у текущего аккаунта.
         * @summary Отвязать Telegram
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkTelegram(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkTelegram(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountTelegramApi.unlinkTelegram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountTelegramApi - factory interface
 * @export
 */
export const AccountTelegramApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountTelegramApiFp(configuration)
    return {
        /**
         * Возвращает `t.me/<bot>?start=<token>` и время истечения (TTL 10 минут). 
         * @summary Создать одноразовый deep link для привязки Telegram
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkToken(options?: RawAxiosRequestConfig): AxiosPromise<AccountTelegramLinkTokenResponse> {
            return localVarFp.createLinkToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Узнать подключён ли Telegram
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTelegramLinkStatus(options?: RawAxiosRequestConfig): AxiosPromise<AccountTelegramLinkStatusResponse> {
            return localVarFp.getTelegramLinkStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Очищает `telegram_chat_id` у текущего аккаунта.
         * @summary Отвязать Telegram
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkTelegram(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlinkTelegram(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountTelegramApi - object-oriented interface
 * @export
 * @class AccountTelegramApi
 * @extends {BaseAPI}
 */
export class AccountTelegramApi extends BaseAPI {
    /**
     * Возвращает `t.me/<bot>?start=<token>` и время истечения (TTL 10 минут). 
     * @summary Создать одноразовый deep link для привязки Telegram
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountTelegramApi
     */
    public createLinkToken(options?: RawAxiosRequestConfig) {
        return AccountTelegramApiFp(this.configuration).createLinkToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Узнать подключён ли Telegram
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountTelegramApi
     */
    public getTelegramLinkStatus(options?: RawAxiosRequestConfig) {
        return AccountTelegramApiFp(this.configuration).getTelegramLinkStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Очищает `telegram_chat_id` у текущего аккаунта.
     * @summary Отвязать Telegram
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountTelegramApi
     */
    public unlinkTelegram(options?: RawAxiosRequestConfig) {
        return AccountTelegramApiFp(this.configuration).unlinkTelegram(options).then((request) => request(this.axios, this.basePath));
    }
}



